{
  "updated": "updated",
  "others": "others",
  "and": "and",
  "builder": "builder",
  "for": "for",
  "emptyAlerts": "No alerts available",
  "noteAddedOn": "added a note on",
  "in": "in",
  "eventName": "the <1>{{name}}</1> event",
  "hubName": "in the <1>{{name}}</1> hub",
  "kudosText": "gave you a kudos on",
  "published": "published",
  "to": "to",
  "startDate": "start date",
  "endDate": "end date",
  "type": "event type",
  "haveBeenUpdated": "have been updated",
  "hasBeenUpdated": "has been updated",
  "hasBeenDeleted": "has been deleted",
  "postedIn": "posted in",
  "repliedTo": "replied to",
  "yourPostOn": "your post on",
  "repliedToAPostYouCommentedOn": "replied to a post you commented on",
  "gaveBoostOnPost": "gave you a boost on your post in",
  "gaveBoostOnReply": "gave you a boost on your comment in",
  "announcementCreated": "There is an announcement by",
  "lastBeen": "since you last have been",
  "answeredAQuestion": "answered a Question",
  "answeredYourQuestion": "answered your Question",
  "kudosToYour": "kudos to your",
  "updvotedYourAns": "upvoted your Answer",
  "youWereAddedToThe": "You were added to the",
  "group": "group"
}
